module.exports = __webpack_public_path__ + "img/6.198495c8.png";